import watchFeature from '../assets/js/api/feature'

export default function (context) {
  for (const route of context.route.matched) {
    try {
      const feature = route.components.default.options.feature

      if (!feature) {
        continue
      }

      const watchedFeatures = context.$auth.$state.user.watched_features.slice()

      if (watchedFeatures.includes(feature)) {
        continue
      }

      context.$store = context.store

      watchFeature.bind(context)(feature)
    } catch (e) {
      // ignore this component, has no feature key
    }
  }
}
